"use client";

import { useAuthStore } from "@/app/store/use-auth-store";
import { usePlatformStore } from "@/entities/platform";
import BottomNavigation from "@/widgets/bottom-navigation/ui/bottom-navigation";
import { Box, Flex } from "@chakra-ui/react";
import AlertAuth from "./ui/alert-auth";
import ProfileOptions from "./ui/profile-options";
import UserDetails from "./ui/user-details";

const ProfilePage = () => {
  const { user } = useAuthStore();
  const { isPorte } = usePlatformStore();

  return (
    <>
      <Flex direction="column" gap="5" h="100vh" bg="gray.50">
        <Box bg="white" shadow="xs" roundedBottom="2xl">
          {user || isPorte ? <UserDetails user={user} /> : <AlertAuth />}
        </Box>

        <ProfileOptions user={user} />
      </Flex>
      <BottomNavigation />
    </>
  );
};

export default ProfilePage;
